class GlobalNiceSelector extends HTMLElement {
  _options = [];

  constructor() {
    super();

    this._options = [
      {
        label: "United States",
        national: "United States",
        id: "united-states-usd",
        domain: "gomilitar.com",
        currency: "USD",
      },
      {
        label: "Canada",
        national: "Canada",
        id: "canada-cad",
        domain: "ca.gomilitar.com",
        currency: "CAD",
      },
      {
        label: "Australia",
        national: "Australia",
        id: "australia-aud",
        domain: "au.gomilitar.com",
        currency: "AUD",
      },
      {
        label: "United Kingdom",
        national: "United Kingdom",
        id: "united-kingdom-gbp",
        domain: "gomilitar.co.uk",
        currency: "GBP",
      },
      {
        label: "Europe",
        national: "Europe EU",
        id: "europe-eur",
        domain: "gomilitar.eu",
        currency: "EUR",
      },
      {
        label: "Germany",
        national: "Deutschland",
        id: "germany-eur",
        domain: "gomilitar.de",
        currency: "EUR",
      },
      {
        label: "Sweden",
        national: "Sverige",
        id: "sweden-sek",
        domain: "gomilitar.se",
        currency: "SEK",
      },
      {
        label: "Poland",
        national: "Polska",
        id: "poland-pln",
        domain: "gomilitar.pl",
        currency: "PLN",
      },
      {
        label: "France",
        national: "Francja",
        id: "france-eur",
        domain: "gomilitar.fr",
        currency: "EUR",
      },
      {
        label: "Italy",
        national: "Italia",
        id: "italy-eur",
        domain: "gomilitar.it",
        currency: "EUR",
      },
      {
        label: "Netherlands",
        national: "Nederland",
        id: "netherlands-eur",
        domain: "gomilitar.nl",
        currency: "EUR",
      },
      {
        label: "Spain",
        national: "España",
        id: "spain-eur",
        domain: "gomilitar.es",
        currency: "EUR",
      },
      {
        label: "Belgium",
        national: "België",
        id: "belgium-eur",
        domain: "gomilitar.be",
        currency: "EUR",
      },
    ];
    this.attachShadow({ mode: "open" }); // Create shadow DOM
  }

  connectedCallback() {
    const currentValue = this.getAttribute("data-current") || "global-usd";

    this.shadowRoot.innerHTML = `
        <style>        
          .selector-container {
            display: flex;
            align-items: center;
            cursor: pointer;
            background-color: var(--background-color);
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 10px;
            transition: background-color 0.3s;
            margin-bottom: 16px;
          }
          .selector-container:hover {
            background-color: #f1f1f1;
          }
          .icon {
            width: var(--icon-size);
            height: var(--icon-size);
            background-color: #3968a4;
            border-radius: 50%;
            margin-right: 10px;
          }
          .text {
            flex: 1;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-color);
            white-space: nowrap;
            overflow: hidden;
            text-align: left;
            text-overflow: ellipsis;
          }
          .text:hover {
            text-decoration: underline;
          }
          .options-wrap {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 5px;
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            z-index: 10;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
          }
          .options-wrap.is-open {
            display: block;
          }
          .option {
            padding: 10px;
            display: flex;
            align-items: center;
            cursor: pointer;
            border-bottom: 1px solid #ddd;
            transition: background-color 0.3s;
          }
          .option:last-child {
            border-bottom: none;
          }
          .option:hover {
            background-color: #f1f1f1;
          }
          .option.is-selected {
            font-weight: 600;
          }
          .option-icon {
            width: var(--icon-size);
            height: var(--icon-size);
            background-color: #3968a4;
            border-radius: 50%;
            margin-right: 10px;
          }
          .action-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          }
          .selector-wrapper {
            position: relative;
          }
          .ter-select-item::before {
            content: " ";
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-size: contain;
            padding-right: 10px;
           }
          .ter-select-item[data-value="global-usd"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/global_flag_selector_small_df9cfb5b-2091-43df-add5-108286fbb382.png");
}
.ter-select-item[data-value="united-states-usd"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/usa_flag_selector_small_c6958074-8ffc-4bfd-9e48-7bd59b45a071.png");
}
.ter-select-item[data-value="canada-cad"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/canada_flag_selector_small_f15ffdce-3888-4903-b7a2-c46de4f38be3.png");
}
.ter-select-item[data-value="australia-aud"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/australia_flag_selector_small_ab8d6de2-b8d0-48b3-938a-f8015637f07b.png");
}
.ter-select-item[data-value="united-kingdom-gbp"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/UK_flag_selector_small_fc9c60fb-c5a8-49c6-b637-b3561cc582a3.png");
}
.ter-select-item[data-value="europe-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/europe_flag_selector_small_82666beb-f840-4c88-97c3-e7c80a833309.png");
}
.ter-select-item[data-value="germany-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/germany_flag_selector_small_ca0365b3-c48b-4222-9fac-eca9e637b591.png");
}
.ter-select-item[data-value="sweden-sek"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/sweden_small_f4650579-82ed-4a42-aa30-5ec956b8f375.png");
}
.ter-select-item[data-value="poland-pln"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/poland-flag_small_8694aa9c-b096-4e6d-b220-7e14c39a1feb.png");
}
.ter-select-item[data-value="france-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/france_flag_selector_small_af2cdbff-acc7-4265-b77b-ca9f3d2dac80.png");
}
.ter-select-item[data-value="italy-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/italy_small_42faea98-f97a-469b-b5f6-87560f077cce.png");
}
.ter-select-item[data-value="netherlands-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/nl-circle-01-S.png");
}
.ter-select-item[data-value="spain-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/spain_small_11e0cce1-407a-4c6d-b587-e563814f22cb.png");
}
.ter-select-item[data-value="belgium-eur"]::before {
  background-image: url("https://cdn.shopify.com/s/files/1/0550/4974/8721/files/be-circle-01-S.png");
}
.option-text {
  line-height: 1em;
}
.option-text, .option-text-ad {
  text-align: left !important;
}
.option-text-ad {
  display: block;
  font-size: 12px;
}
.stack {
display: flex;
flex-direction: column;
}
        </style>

        <div class="selector-wrapper">
          <div class="selector-container ter-select-item" data-value="${currentValue}" id="selector">
            <div class="text">Select...</div>
          </div>
           <div class="options-wrap" id="options">
            ${this._options
              .map((option) => {
                const { label, id, domain, currency } = option;
                return `<div class="option ter-select-item" data-value="${id}" data-url="https://${domain}/">
                <div class="stack">
                  <div class="option-text">${label} / ${currency}</div>
                  ${option.national ? `<div class="option-text-ad">${option.national}</div>`: ''}
                </div>
              </div>`;
              })
              .join("")}
          </div>
        </div>
      `;

    const defaultOption = this.shadowRoot.querySelector(
      `.option[data-value="${this._options[0].id}"]`
    );
    if (defaultOption) {
      this._selectOption(defaultOption);
    }

    this._initListeners();
  }

  _initListeners() {
    const selectorContainer = this.shadowRoot.querySelector("#selector");
    const optionsWrap = this.shadowRoot.querySelector("#options");
    const optionElements = optionsWrap.querySelectorAll(".option");

    selectorContainer.addEventListener("click", () => {
      this._toggleOptions(optionsWrap);
    });

    optionElements.forEach((option) => {
      option.addEventListener("click", () => {
        this._selectOption(option);
      });
    });
  }

  _toggleOptions(optionsWrap) {
    const isOpen = optionsWrap.classList.toggle("is-open");
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Lock scrolling
      document.body.style.maxHeight = "100vh";
    } else {
      document.body.style.overflow = ""; // Unlock scrolling
      document.body.style.maxHeight = "";
    }
  }

  _selectOption(option) {
    const selectedValue = option.getAttribute("data-value");
    const text = option.querySelector(".option-text").textContent;
    this.shadowRoot.querySelector(".text").textContent = text;
    this.shadowRoot
      .querySelector(".selector-container")
      .setAttribute("data-value", selectedValue);

    // Update the element's attributes
    this.setAttribute("data-value", selectedValue);
    this.setAttribute("data-url", option.getAttribute("data-url"));

    // Highlight the selected option and close the dropdown
    this.shadowRoot.querySelectorAll(".option").forEach((opt) => {
      opt.classList.remove("is-selected");
    });
    option.classList.add("is-selected");

    const optionsWrap = this.shadowRoot.querySelector("#options");
    optionsWrap.classList.remove("is-open");
    
    // Unlock scrolling when selection is made
    document.body.style.overflow = "";
  }
}

customElements.define("global-nice-selector", GlobalNiceSelector);
